import axios from 'axios';

import { ROUTE_GET, ROUTE_FROM_GET } from '@/store/modules/route';

import { baseUrlMapper, apiKeyMapper, apiUrl } from './const';
import {
  getBaseParams,
  getCommonParams,
} from './utils';

// 创建axios实例，用于发送埋点请求
const apiInstance = axios.create({
  headers: {
    'Content-Type': 'application/json',
    apiKey: apiKeyMapper[process.env.VUE_APP_ENV],
  },
});

// 埋点管理器类：负责处理所有埋点相关的操作
class EventTrackManager {
  // 初始化类的必要属性
  constructor() {
    this.store = null; // 存储Vuex实例
    this.i18n = null; // 存储i18n实例
  }

  // 初始化方法：设置Vuex store和i18n实例
  init(store, i18n) {
    this.store = store; // 保存Vuex store实例
    this.i18n = i18n; // 保存i18n实例
  }

  // 发送埋点数据的核心方法
  async send(params) {
    try {
      // 检查是否已经初始化必要的实例
      if (!this.store || !this.i18n) {
        console.warn('EventTrackManager not initialized with store and i18n');
        return;
      }

      // 获取所有通用参数
      const commonParams = getCommonParams(this.store, {
        to: this.store.getters[ROUTE_GET], // 获取目标路由信息
        from: this.store.getters[ROUTE_FROM_GET], // 获取来源路由信息
      }, this.i18n);

      // 合并通用参数和自定义参数
      const finalParams = {
        ...commonParams, // 展开通用参数
        ...params, // 展开自定义参数，允许覆盖通用参数
      };

      // 输出环境信息，用于调试
      console.log('process.env.NODE_ENV---', process.env.NODE_ENV);
      console.log('process.env.VUE_APP_ENV---', process.env.VUE_APP_ENV);

      try {
        // 发送埋点请求到服务器
        apiInstance.post(baseUrlMapper[process.env.VUE_APP_ENV] + apiUrl, finalParams);
      } catch (error) {
        // 处理请求错误
        console.error('Failed to send event track:', error);
      }
    } catch (error) {
      // 处理其他可能的错误
      console.error('Error in event track:', error);
    }
  }
}

// 创建埋点管理器单例
const eventTrackManager = new EventTrackManager();

// 导出埋点管理器实例
export { eventTrackManager };
